"use strict";
/** @module Survey-Taking Index */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyTakingQuestionClient = void 0;
var survey_taking_question_client_1 = __importDefault(require("./survey-taking-question-client"));
exports.SurveyTakingQuestionClient = survey_taking_question_client_1.default;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLGtDQUFrQzs7Ozs7O0FBR2xDLGtHQUEyRjtBQUkxRixxQ0FKTSx1Q0FBMEIsQ0FJTiJ9